export default "__VITE_ASSET__cArINpWH__"